/* eslint-disable prettier/prettier */
export const currentState =(state)=>{    
return state.status
}
export const courtOrderData = (state)=>{
    return state.courtOrderData
}
export const dataSegip =(state)=>{    
    return state.segipResponse
}
export const listPpl =(state)=>{
     return state.listPrivatedLibertyPersons
}
export const dataToEdit =(state)=>{
     return {"data":state.dataToEdit , "state": state.statusEdit}
}
export const countCentersByPersons =(state)=>{
    return state.countPersonsCenter
}
export const chartDataValues =(state)=>{
    return state.chartData
}
export const chartDataTwoParams =(state)=>{
    return state.chartDataTwoParams
}
export const chartStatus =(state)=>{
    return state.chartStatus
}
// export const username =(state)=>{    
//     return `${state.user.nombres||''}  ${state.user.primer_apellido||''}  ${state.user.segundo_apellido||''}`
//     }
// export const email =(state)=>{    
//     return `${state.user.correo_electronico}`
//     }